export const COUNT_NAVIGATION_LINKS = 8;
export const COUNT_PROVIDERS_NAVIGATION_LINKS = 5;

export const getCollection = (
  collection = [],
  isExpanded = false,
  initialCount = COUNT_NAVIGATION_LINKS
) => {
  const additionalItem = { id: 'all-id', isExpandButton: true };
  const countItems = collection.length;

  if (isExpanded) {
    return [...collection, additionalItem];
  }

  if (countItems > initialCount) {
    return [...collection.slice(0, initialCount - 1), additionalItem];
  }

  return collection;
};
